import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
	return (
		<footer className="app-footer">
			<p>
				ORDR is a registered trademark of PMORDR, Inc. &nbsp;©{new Date().getFullYear()} PMORDR, Inc. &nbsp;&middot;&nbsp;
				<Link to="/terms-of-service">Terms of use</Link> &nbsp;&middot;&nbsp;
				<Link to="/privacy-policy">Privacy policy</Link>
			</p>
		</footer>
	);
}
